<template>
  <div class="layout-cart-header">
    <div class="s-16 w-600 uppercase prefix"><slot name="prefix"></slot></div>
    <div class="title s-65 font-palantino"><slot name="title"></slot></div>
    <!--  -->
    <div class="steps">
      <a
        :href="step.link"
        class="step"
        :class="[{ active: step.active }]"
        :style="`z-index: ${steps.length - index}`"
        v-for="(step, index) in steps"
        :key="index"
      >
        <div class="step-name s-12 uppercase">{{ step.name }}</div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layout-cart-header {
  text-align: center;
  padding: 3em 0;
  --size: 100px;
}
.title {
  * {
    font: inherit;
  }
}
.title {
  font-size: 45px;
}
.steps {
  display: flex;
  flex-flow: wrap;
  justify-content: center;
  margin-top: 21px;
  position: relative;
  font-size: 12px;
  line-height: 16px;
}
.step {
  text-align: center;
  margin: 0 0.5em;
  position: relative;
  width: var(--size);
}
.round {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  background: var(--light);
  align-items: center;
  justify-content: center;
  display: inline-flex;
  margin-bottom: 0.5em;
  position: relative;
  z-index: 2;
  .step:not(:first-child) &:before {
    content: '';
    width: var(--size);
    height: 2px;
    background: var(--light);
    position: absolute;
    right: 40px;
    top: 50%;
    transform: translate(0, -50%);
    z-index: -1;
  }
  .step.active &:before {
    background-color: var(--color);
  }
  .step.active & {
    background: var(--color);
    color: #fff;
  }
}
.step.active {
  font-weight: bold;
}
.button-wrapper {
  margin-top: 6em;
}
.prefix {
  margin-bottom: 1em;
  & > * {
    a {
      &:not(:last-child) {
        text-decoration: underline;
        &:after {
          content: '';
          display: inline-block;
          position: relative;
          top: -2px;
          width: 6px;
          height: 6px;
          background: url('../../../assets/icons/small-arrow.svg');
          background-size: contain;
          background-position: center;
          margin: 0 0.7em;
          background-repeat: no-repeat;
        }
      }
      &:last-child {
        opacity: 0.4;
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .title {
    font-size: 2.8em;
  }
}
</style>
